import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Suitcase.svg",
  "use": "Suitcase.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Suitcase.svg\"><path d=\"M52,52H49a1,1,0,0,1-1-1V17a1,1,0,0,1,1-1h3a4,4,0,0,1,4,4V48A4,4,0,0,1,52,52Zm-7,0H19a1,1,0,0,1-1-1V17a1,1,0,0,1,1-1h2V13a5,5,0,0,1,5-5H38a5,5,0,0,1,5,5v3h2a1,1,0,0,1,1,1V51A1,1,0,0,1,45,52ZM39,13a1,1,0,0,0-1-1H26a1,1,0,0,0-1,1v3H39ZM8,48V20a4,4,0,0,1,4-4h3a1,1,0,0,1,1,1V51a1,1,0,0,1-1,1H12A4,4,0,0,1,8,48Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol